import { render, staticRenderFns } from "./DetailBooking.vue?vue&type=template&id=60d18069&scoped=true"
import script from "./DetailBooking.vue?vue&type=script&lang=js"
export * from "./DetailBooking.vue?vue&type=script&lang=js"
import style0 from "./DetailBooking.vue?vue&type=style&index=0&id=60d18069&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d18069",
  null
  
)

export default component.exports